<div
  class="fixed z-99999 flex flex-col gap-2 pointer-events-none transition-all duration-400 /*
  Mobile: Unten Zentriert */ bottom-1 left-1/2 -translate-x-1/2 w-[90%] max-w-100 /* Desktop (ab sm): Oben Rechts */ sm:top-20
  sm:right-5 sm:bottom-auto sm:left-auto sm:translate-x-0 sm:w-auto">
  @for (toast of svc.toasts(); track toast.id) {
  <div
    class="pointer-events-auto min-w-70 p-4 bg-white rounded-md flex items-center justify-between animate-slide-in"
    [ngClass]="{
           'text-mksoft-active': toast.type === 'success',
           'text-mksoft-red': toast.type === 'error',
           'bg-blue-400/70 text-white': toast.type === 'info'
         }">
    <div class="flex items-center gap-3">
      @if (toast.type === 'success') {
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-mksoft-active lucide lucide-check-icon lucide-check"><path d="M20 6 9 17l-5-5"/></svg>
      } @if (toast.type === 'error') {
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="w-5 h-5 text-mksoft-red lucide lucide-circle-x-icon lucide-circle-x">
        <circle cx="12" cy="12" r="10" />
        <path d="m15 9-6 6" />
        <path d="m9 9 6 6" />
      </svg>
      } @if (toast.type === 'info') {
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="w-5 h-5 text-smartsheep-bark lucide lucide-log-out-icon lucide-log-out">
        <path d="m16 17 5-5-5-5" />
        <path d="M21 12H9" />
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      </svg>
      }
      <span class="text-sm font-semibold text-smartsheep-bark">{{ toast.message }}</span>
    </div>
    <div
      class="absolute bottom-0.5 left-1 right-1 h-1 rounded-bl-md rounded-br-md"
      [ngClass]="{ 'bg-green-100': toast.type === 'success', 'bg-red-200': toast.type === 'error','text-smartsheep-bark': toast.type === 'info' }">
      <div
        class="h-full bg-current opacity-30 animate-progress"
        [ngClass]="{ 'text-mksoft-green': toast.type === 'success', 'bg-red-700': toast.type === 'error', 'text-smartsheep-bark': toast.type === 'info' }"></div>
    </div>
  </div>
  }
</div>
